.vx_tooltip__parent {
  display: flex;
}

.vx_tooltip__container {
  position: relative;
  color: #565657;
}
.vx_tooltip__container--hoverable:hover .vx_tooltip__content {
  display: block;
}

.vx_tooltip__content {
  position: absolute;
  right: 0;
  top: -5px;
  transform: translateY(-100%);
  width: max-content;
  max-width: 50vw;
  padding: 4px;
  font-size: 0.714em;
  background-color: var(--ci-neutral100);
  border: 1px solid var(--ci-neutral300);
  border-radius: 4px;
  color: inherit;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}
.vx_tooltip__content--hoverable {
  display: none;
}
.vx_tooltip__content::after {
  content: " ";
  position: absolute;
  top: 100%;
  right: 13px;
  margin-left: -5px;
  border-width: 8px;
  border-style: solid;
  border-color: var(--ci-neutral400) transparent transparent transparent;
}

@media only screen and (min-width: var(--blob, 768px)) {
  .vx_tooltip__content {
    right: 0;
    width: 250px;
  }
}